(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WISH_KEY = 'wm_wishlist';
    function readWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
    function writeWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} }

    function init(root) {
      if (!root || root.dataset.wmReady) return;
      root.dataset.wmReady = '1';

      // sort
      var sort = root.querySelector('[data-wm-sort]');
      if (sort) sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      // drawer
      var drawer = root.querySelector('[data-wm-drawer]');
      var opener = root.querySelector('[data-wm-open]');
      function open() {
        if (!drawer) return;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.documentElement.classList.add('wm-lock');
        if (opener) opener.setAttribute('aria-expanded', 'true');
        var first = drawer.querySelector('summary, input, button');
        if (first) first.focus({ preventScroll: true });
      }
      function close() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('wm-lock');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
        setTimeout(function () { drawer.hidden = true; }, 300);
      }
      if (opener) opener.addEventListener('click', open);
      if (drawer) {
        drawer.querySelectorAll('[data-wm-close]').forEach(function (el) { el.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
        drawer.querySelectorAll('[data-wm-more]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var list = btn.previousElementSibling;
            var open = list.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.textContent = open ? btn.dataset.less : btn.dataset.more;
          });
        });
        // drop empty price inputs so they don't create empty filters
        var form = drawer.querySelector('form');
        if (form) form.addEventListener('submit', function () {
          form.querySelectorAll('[data-wm-family]').forEach(function (cb) {
            cb.closest('label').querySelectorAll('[data-wm-member]').forEach(function (m) { m.disabled = !cb.checked; });
          });
          form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
        });
      }

      // swatches: switch the card to that color instead of opening the product page
      root.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-wm-swatch]');
        if (!sw || !root.contains(sw)) return;
        e.preventDefault();
        var card = sw.closest('.wm-card');
        if (!card) return;
        var url = sw.dataset.url;
        card.querySelectorAll('.wm-card__img-link, .wm-card__title-link, .wm-card__more').forEach(function (a) { if (url) a.href = url; });
        var main = card.querySelector('.wm-card__img:not(.wm-card__img--hover)');
        if (main && sw.dataset.img) {
          card.classList.add('is-switching');
          var done = function () { card.classList.remove('is-switching'); };
          main.addEventListener('load', done, { once: true });
          main.addEventListener('error', done, { once: true });
          main.loading = 'eager';
          main.removeAttribute('srcset');
          main.src = sw.dataset.img;
          if (main.complete) done();
        }
        var hover = card.querySelector('.wm-card__img--hover');
        if (hover) {
          if (sw.dataset.hover) { hover.removeAttribute('srcset'); hover.src = sw.dataset.hover; hover.hidden = false; }
          else { hover.hidden = true; }
        }
        var color = card.querySelector('.wm-card__color');
        if (color) color.textContent = sw.dataset.color;
        var amount = card.querySelector('.wm-card__amount');
        if (amount && sw.dataset.price) amount.textContent = sw.dataset.price;
        var from = card.querySelector('.wm-card__from');
        if (from) from.hidden = sw.dataset.from !== 'true';
        card.classList.toggle('is-sold-out', sw.dataset.available === 'false');
        card.querySelectorAll('[data-wm-swatch]').forEach(function (b) { b.removeAttribute('aria-current'); });
        sw.setAttribute('aria-current', 'true');
      });

      // family chips: remove every color of that family at once
      root.querySelectorAll('[data-wm-chip-values]').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          var url = new URL(window.location.href);
          var param = chip.getAttribute('data-wm-chip-param');
          var drop = chip.getAttribute('data-wm-chip-values').split('||').filter(Boolean);
          var keep = url.searchParams.getAll(param).filter(function (v) { return drop.indexOf(v) === -1; });
          url.searchParams.delete(param);
          keep.forEach(function (v) { url.searchParams.append(param, v); });
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });

      // wishlist (stored in this browser only)
      var wish = readWish();
      root.querySelectorAll('[data-wm-wish]').forEach(function (btn) {
        var id = btn.getAttribute('data-wm-wish');
        btn.setAttribute('aria-pressed', wish.indexOf(id) > -1 ? 'true' : 'false');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var list = readWish(); var i = list.indexOf(id);
          if (i > -1) list.splice(i, 1); else list.push(id);
          writeWish(list);
          btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
        });
      });
    }

    function boot() { document.querySelectorAll('[data-wm-grid]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) {
      document.documentElement.classList.remove('wm-lock');
      init(e.target.querySelector('[data-wm-grid]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-collection-seo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-wm-seo-toggle]').forEach(function (btn) {
        if (btn.dataset.wmReady) return;
        btn.dataset.wmReady = '1';
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (!body) return;
        if (body.scrollHeight <= body.clientHeight + 4) { body.classList.add('is-open'); btn.hidden = true; return; }
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync(root) {
      var acc = root.classList.contains('wm-ft--accordion');
      root.querySelectorAll('.wm-ft__col').forEach(function (d) {
        if (!acc || !mq.matches) d.setAttribute('open', '');
        else if (!d.dataset.wmTouched) d.removeAttribute('open');
      });
    }
    function init(root) {
      if (!root || root.dataset.wmReady) return;
      root.dataset.wmReady = '1';
      sync(root);
      root.querySelectorAll('.wm-ft__col-title').forEach(function (sum) {
        sum.addEventListener('click', function (e) {
          if (!(root.classList.contains('wm-ft--accordion') && mq.matches)) { e.preventDefault(); return; }
          sum.parentElement.dataset.wmTouched = '1';
        });
      });
      root.querySelectorAll('[data-wm-autosubmit]').forEach(function (sel) {
        sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
      });
    }
    function boot() { document.querySelectorAll('[data-wm-footer]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    (mq.addEventListener ? mq.addEventListener('change', function () { document.querySelectorAll('[data-wm-footer]').forEach(sync); }) : mq.addListener(function () { document.querySelectorAll('[data-wm-footer]').forEach(sync); }));
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-wm-footer]')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
